import { takeLatest, takeEvery } from 'redux-saga/effects';
import { INFORMATION_LOG_MODULE } from '../../../configs/moduleNames';
import { CREATE_INFORMATION, LOAD_INFORMATION_BY_ID, LOAD_INFORMATION_LOG_LIST } from '../actions';
import loadInformationList from './loadInformationList';
import loadInformationById from './loadInformationById';
import createApplication from './createInformation';

export default function* watchClient() {
  yield takeLatest(INFORMATION_LOG_MODULE + LOAD_INFORMATION_LOG_LIST, loadInformationList);
  yield takeEvery(INFORMATION_LOG_MODULE + LOAD_INFORMATION_BY_ID, loadInformationById);
  yield takeEvery(INFORMATION_LOG_MODULE + CREATE_INFORMATION, createApplication);
}
